import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, Typography } from 'investira.react.components';

/**
 * Renderiza o componente SingleTextarea.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*|string|Array} props.title - Título exibido pelo componente.
 * @param {string} props.caption - Propriedade `caption` do componente.
 * @param {Object} props.InputProps - Props adicionais repassadas ao input interno.
 * @param {Object} props.restProps - Props adicionais repassadas para `restProps`.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const SingleTextarea = memo(props => {
    const { title, caption, InputProps, ...restProps } = props;
    const { sx, ...restInputProps } = InputProps;

    return (
        <Box>
            {title && (
                <Typography
                    variant="h5"
                    color="text.primary"
                    sx={{
                        fontWeight: 500,
                        mb: 1
                    }}>
                    {title}
                </Typography>
            )}
            {caption && (
                <Typography variant="caption" color="text.primary">
                    {caption}
                </Typography>
            )}
            <Box padding={2}></Box>
            <TextField
                {...restProps}
                InputProps={{
                    sx: {
                        fontSize: '1.2rem',
                        padding: '1.5rem 1rem 1rem 1rem',
                        ...sx
                    },
                    ...restInputProps
                }}
                fullWidth
                multiline
                maxRows={4}
            />
        </Box>
    );
});

SingleTextarea.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    caption: PropTypes.string,
    InputProps: PropTypes.object
};

SingleTextarea.defaultProps = {
    title: '',
    caption: '',
    InputProps: {}
};

SingleTextarea.displayName = 'SingleTextarea';

export default SingleTextarea;
